import { render, staticRenderFns } from "./TariffSetting.vue?vue&type=template&id=877a591e&scoped=true"
import script from "./TariffSetting.vue?vue&type=script&lang=js"
export * from "./TariffSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877a591e",
  null
  
)

export default component.exports